
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ElementRef, Renderer2 } from '@angular/core';
import { CoreService } from '../../../services/core.service';
import { CommonModule } from '@angular/common';
import { map, catchError, take } from "rxjs/operators";
import { forkJoin, of } from "rxjs";
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEl from '@angular/common/locales/el';
import { LOCALE_ID } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../../environments/environment';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSnackBarRef } from '@angular/material/snack-bar';


registerLocaleData(localeEl);

@Component({
  selector: 'app-instagram-post',
  imports: [NgIf, CommonModule,MatIconModule],
  providers: [DatePipe, { provide: LOCALE_ID, useValue: 'en' }],
  templateUrl: './instagram-post.component.html',
  styleUrl: './instagram-post.component.scss'
})
export class InstagramPostComponent {

  id: string | null = null;
  companyID: number = 0;
  siteDomain: string = 'dummy.view';
  creatomateVideo: number = 0;
  switchboardImage: number = 0;
  mainImageUrl: string = '';
  postFeed: string = 'dummy.view';
    thumbnailFilePath: string = '';
  postTitle: string = '';
  postDescription: string = '';
  articleUrl: string = '';
  scheduledFor: Date | null = null;
  formattedDate: string = 'dummy.date';
  postStatus: string = '';
  textDirection: 'ltr' | 'rtl' = 'ltr';

  private updatingToastRef: MatSnackBarRef<any> | null = null;



  socialTag: string = '';
  private readonly VIDEO_TAGS = new Set([
    'fbvideo',
    'igvideo',
    'igreel',
    'fbstoryvideo',
    'igstoryvideo',
    'tiktokstoryvideo',
    'tiktokcarousel',
    'tiktokvideo'
  ]);

  //video
  isVideo: boolean = false; 
  videoUrl: string = '';   

  // carousel
  isCarousel: boolean = false;
  carouselImages: string[] = [];
  currentIndex: number = 0;

  // autoplay
  private autoplayId: any = null;
  private autoplayDelay = 3500; 
  private autoplayPaused = false;

  constructor(
    private http: HttpClient,
    private readonly coreService: CoreService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private datePipe: DatePipe,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    //window.location.reload(); 
    this.companyID = this.coreService.user?.companyID || 0;
    this.id = this.route.snapshot.paramMap.get("id");
    if (this.id) {
      this.loadPost(this.id);
    }
  }

  loadPost(id: string): void {
    this.coreService.getData(`/manual-post/editPost/${this.companyID}/${id}`)
      .pipe(take(1))
      .subscribe((res: any) => {
        if (!res) {
          this.coreService.showSnackbar("Post not found.");
          return;
        }

        // console.log(res);

        this.siteDomain = res.Domain.replace('https://www.', '');
        this.textDirection = (res.text_direction === 'rtl') ? 'rtl' : 'ltr';

        this.postStatus = res.post_status;    
        this.socialTag = res.social_tag;
        const statusOk = this.postStatus !== 'Fail Permanently' && this.postStatus !== 'Failed';
        const tag = (this.socialTag || '').trim().toLowerCase();
        const isVideoTag = statusOk && this.VIDEO_TAGS.has(tag);

        const rawVideoUrl = (res.video_url && String(res.video_url).trim()) || '';

        if (isVideoTag && !rawVideoUrl) {
          this.showUpdatingToast();
        } else {
          this.hideUpdatingToast();
        }

        // Video
        this.isVideo = this.isVideoPost(
          this.postStatus,
          this.socialTag,
          res.createomate_video
        );

        const rawVideo =
          (res.createomate_video && String(res.createomate_video).trim()) ||
          (res.video_url && String(res.video_url).trim()) ||
          '';

        if (this.isVideo && rawVideo) {
          this.videoUrl = rawVideo;
        } else {
          this.isVideo = false;
          this.videoUrl = '';

          const rssMainImage = (res.rss_img_url && String(res.rss_img_url).trim()) || '';
          if (rssMainImage) {
            this.mainImageUrl = rssMainImage;
          }
        }

        if (this.videoUrl && !/^https?:\/\//i.test(this.videoUrl)) {
          const path = this.videoUrl.startsWith('/storage/')
            ? this.videoUrl
            : '/storage/' + this.videoUrl.replace(/^\/+/, '');

          const origin = environment.baseUrl.replace(/\/api\/?$/i, '');
          this.videoUrl = `${origin}${path}`;
        }
        
        //Carousel
        this.isCarousel =
          this.socialTag === 'igcarousel' &&
          this.postStatus !== 'Fail Permanently' &&
          this.postStatus !== 'Failed' &&
          Array.isArray(res.image_array) &&
          res.image_array.length > 0;

          if (this.isCarousel) {
            this.carouselImages = res.image_array;
            this.currentIndex = 0;
            this.mainImageUrl = this.carouselImages[0]; 

             this.startAutoplay();
          } else {
            this.carouselImages = [];
            this.stopAutoplay(); 

            if (res.switchboard_img != null) {
              this.switchboardImage = 1;
            }
            this.mainImageUrl =
              this.switchboardImage == 1 ? res.switchboard_img : res.image_array[0];
          }

          this.postFeed = res.feed;
          this.thumbnailFilePath = res.thumbnail_file_path;
          this.postTitle = res.rss_title;

          const maxChars = 250;
          this.postDescription =
            res.rss_description.length > maxChars
              ? res.rss_description.substring(0, maxChars) + '...'
              : res.rss_description;

          this.articleUrl = res.article_url;
          this.scheduledFor = new Date(res.scheduled_for);
          this.formattedDate =
            this.datePipe.transform(this.scheduledFor, 'd MMMM YYYY') || '';

          const element = this.elRef.nativeElement.querySelector('.instagram-card');
          this.renderer.removeClass(element, 'hidden');
        });
  }

  isVideoPost(
      status: string | null | undefined,
      tag: string | null | undefined,
      videoUrl?: string | null | undefined
    ): boolean {
      const s = (status || '').trim();
      const t = (tag || '').trim().toLowerCase();
      const hasVideoUrl = !!videoUrl;

      if (s === 'Fail Permanently' || s === 'Failed') {
        return false;
      }
       if (t === 'igcarousel') {
      return false;
    }

      if (hasVideoUrl) {
        return true;
      }
      return this.VIDEO_TAGS.has(t);
  }

  nextSlide(): void {
    if (!this.isCarousel || this.carouselImages.length === 0) return;
    this.currentIndex = (this.currentIndex + 1) % this.carouselImages.length;
  }

  prevSlide(): void {
    if (!this.isCarousel || this.carouselImages.length === 0) return;
      this.currentIndex =
        (this.currentIndex - 1 + this.carouselImages.length) % this.carouselImages.length;
  }

  goToSlide(index: number): void {
    if (!this.isCarousel || this.carouselImages.length === 0) return;
    if (index < 0 || index >= this.carouselImages.length) return;
    this.currentIndex = index;
  }

  private startAutoplay(): void {
    if (!this.isCarousel || this.autoplayId) return;

    this.autoplayId = setInterval(() => {
      if (!this.isCarousel || this.carouselImages.length === 0) return;
      if (this.autoplayPaused) return;
      this.nextSlide();
    }, this.autoplayDelay);
  }

  private stopAutoplay(): void {
    if (this.autoplayId) {
      clearInterval(this.autoplayId);
      this.autoplayId = null;
    }
  }

  pauseAutoplay(): void {
    this.autoplayPaused = true;
  }

  resumeAutoplay(): void {
    this.autoplayPaused = false;
  }

  ngOnDestroy(): void {
    this.stopAutoplay();
  }

  private showUpdatingToast(): void {
    if (this.updatingToastRef) return; 
    this.updatingToastRef = this.snackBar.open('Updating preview content', undefined, {
      duration: 0,            
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  private hideUpdatingToast(): void {
    if (this.updatingToastRef) {
      this.updatingToastRef.dismiss();
      this.updatingToastRef = null;
    }
  }


}